'use client'

// src/utils/utm.ts
import { getItem, safeParseJson } from "@wbk/utils";
var getAnalyticsUtms = () => {
  if (typeof window !== "undefined") {
    const search = new URLSearchParams(window.location.search);
    const utm_wbk_wa_session_id = getItem("utm_wbk_wa_session_id");
    const allParams = {};
    search.forEach((value, key) => {
      allParams[key] = value;
    });
    if (Object.keys(allParams).length > 0 && utm_wbk_wa_session_id) {
      allParams.utm_wbk_wa_session_id = utm_wbk_wa_session_id;
    }
    return Object.keys(allParams).length > 0 ? allParams : void 0;
  }
};
var getAnalyticsUtmsFromStorage = () => {
  if (typeof window !== "undefined") {
    const savedUtms = getItem("utms");
    return savedUtms ? safeParseJson(savedUtms) : null;
  }
};

export {
  getAnalyticsUtms,
  getAnalyticsUtmsFromStorage
};
//# sourceMappingURL=chunk-LOKZ6BXB.mjs.map